var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBell = function SvgBell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8433 2C11.0148 2 10.3433 2.67157 10.3433 3.5V7H13.3433V3.5C13.3433 2.67157 12.6717 2 11.8433 2ZM11.8433 22C13.224 22 14.3433 20.6569 14.3433 19C14.3433 17.3431 13.224 16 11.8433 16C10.4625 16 9.34326 17.3431 9.34326 19C9.34326 20.6569 10.4625 22 11.8433 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34314 16C2.88562 16.4575 2.88562 17.1993 3.34314 17.6568C3.56285 17.8765 3.86084 18 4.17156 18H19.5147C20.1618 18 20.6863 17.4755 20.6863 16.8284C20.6863 16.5177 20.5629 16.2197 20.3431 16C18.8218 14.4786 18.1818 15.7675 17.8431 11C17.5282 6.56704 15.8431 4.5 11.8431 4.5C7.84314 4.5 6.16322 6.59195 5.84314 11C5.4972 15.7644 4.87368 14.4695 3.34314 16Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bell.e64386a1b73358acc4a235b9323d787a.svg";